import React, { useState, useEffect } from 'react';
import { CheckCircle, Radio } from 'lucide-react';

export default function GlobalTicker({ ctx }) {
  const { T, maintenanceMode, api, isEN } = ctx;
  const [items, setItems] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Lädt die Ticker-Nachrichten aus dem Backend
    const load = async () => {
      try {
        const data = await api('/ticker');
        setItems(data);
      } catch(e) {}
    };
    
    load();
    const int = setInterval(load, 30000);
    
    // 🚀 LIVE UPDATE: Wenn das Backend "new_broadcast" ruft, sofort neu laden!
    window.addEventListener('new_broadcast', load);
    
    return () => {
      clearInterval(int);
      window.removeEventListener('new_broadcast', load);
    };
  }, [api]);

  useEffect(() => {
    if (items.length <= 1) return;
    const int = setInterval(() => {
      setCurrentIndex(old => (old + 1) % items.length);
    }, 10000);
    return () => clearInterval(int);
  }, [items.length]);

  // 🚨 WARTUNGSMODUS-PILLE
  if (maintenanceMode) {
    return (
      <div style={{ background: "rgba(245,158,11,0.15)", border: "1px solid rgba(245,158,11,0.4)", color: "#F59E0B", padding: "6px 20px", borderRadius: 100, display: "flex", justifyContent: "center", alignItems: "center", gap: 8, maxWidth: 500, width: "100%", boxShadow: "0 4px 12px rgba(245,158,11,0.1)" }}>
        <span style={{ animation: "pulseWarning 2s infinite" }}>⚠️</span>
        <span style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.05em" }}>
          {isEN ? "MAINTENANCE MODE ACTIVE" : "WARTUNGSMODUS"}
        </span>
        <style>{`@keyframes pulseWarning { 0% { opacity: 1; } 50% { opacity: 0.4; } 100% { opacity: 1; } }`}</style>
      </div>
    );
  }

  // WENN KEINE TICKER-MELDUNGEN DA SIND
  if (!items || items.length === 0) {
    return (
      <div style={{ margin: "0 auto", background: T.input, border: `1px solid ${T.border2}`, borderRadius: 100, height: 34, padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "center", maxWidth: 450, width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <CheckCircle size={14} color="#10B981"/>
          <span style={{ fontSize: 12, fontWeight: 600, color: T.textSub }}>{isEN ? "All systems operational." : "Alle Systeme laufen reibungslos."}</span>
        </div>
      </div>
    );
  }

  // ZEIGE DIE AKTUELLE MELDUNG AN
  const currentItem = items[currentIndex] || items[0];

  return (
    <div style={{ margin: "0 auto", background: T.input, border: `1px solid ${T.border2}`, borderRadius: 100, height: 34, padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", maxWidth: 450, width: "100%", boxShadow: "0 2px 8px rgba(0,0,0,0.02)" }}>
      <div key={currentItem.id} style={{ display: "flex", alignItems: "center", gap: 8, animation: "tickerSlide 0.8s cubic-bezier(0.4, 0, 0.2, 1)" }}>
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><Radio size={14} color="#0ECFD9"/></span>
        <span style={{ fontSize: 12, fontWeight: 600, color: T.textSub, letterSpacing: "0.02em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {/* Zeigt jetzt exakt den Text aus der Datenbank an! */}
          {currentItem.text}
        </span>
      </div>
      <style>{`
        @keyframes tickerSlide {
          0% { transform: translateY(20px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}